import angular, { IQService, IWindowService } from 'angular';
import moment from 'moment';

import templateUrl from './leads-conversion-report.component.html';
import { UtilityService } from '../../../../core/services/utility.service';
import { LeadsService } from '../../../../core/services';
import { LeadBatchListResponse, RogersLeadsStatusRM, RogersLeadsConversionAggregate } from '@herbjoy/apex-api-models';

interface Filters {
    City?: any;
    TeamName?: any;
    Mapcode?: any;
    EndDate?: Date;
    StartDate?: Date;
}

interface LeadBatchListVM extends LeadBatchListResponse {
    StartDate?: string;
    EndDate?: string;
}

interface Totals {
    TotalUnAssignedLeads: number;
    TotalAssignedLeads: number;
    TotalLeads: number;
}

export const LeadsConversionReportComponent = {
    controllerAs: "vm",
    templateUrl,
    controller: class LeadsConversionReportController {
        constructor(private $q: IQService, private $window: IWindowService,
            private apexApiUrl: string, private utilityService: UtilityService,
            private leadBatchService: any, private leadsService: LeadsService) {
            'ngInject';
        }

        filters: Filters = {};
        filteredReport: RogersLeadsConversionAggregate[];
        leadBatches: LeadBatchListVM[];
        loaded = false;
        pageSize = 10;
        pageNumber = 1;
        report: RogersLeadsConversionAggregate[];
        reportHeaders: RogersLeadsStatusRM[];
        selectedLeadBatches: LeadBatchListVM[];
        showFilters = true;
        staticTotals: Totals;
        totals: { index: number, total: number }[] = [];

        $onInit() {
            this.loadLeadBatches();
        }

        onExportDetail(detail) {
            // eslint-disable-next-line max-len
            window.location.href = `${this.apexApiUrl}reports/leads-conversion-detail.xlsx?mapareacode=${detail.Mapcode}`;
        }

        onRefreshData() {
            this.loaded = false;
            this.$q.when(this.utilityService.showLoading())
                .then(() => this.loadConversionReport())
                .then(result => {
                    this.reportHeaders = result.StatusHeaders;
                    this.report = result.Report;
                    this.filteredReport = angular.copy(this.report);
                    this.calculateTotals();
                    this.loaded = true;

                })
                .catch(ex => {
                    console.error(ex);
                    alert("Initial load failed: " + this.utilityService.getExceptionMessage(ex));
                })
                .then(() => this.utilityService.hideLoading());
        }

        onExport() {
            const query = {
                MapCode: "",
                BatchIDS: this.selectedLeadBatches.map(function (batch) {
                    return batch.LeadBatchID
                })
            };
            const queryString = this.utilityService.queryStringify(query);
            this.$window.location.href = `${this.apexApiUrl}reports/leads-conversion.xlsx${queryString}`;
        }

        onChangeFilter() {
            this.filteredReport = angular.copy(this.report).filter(p => this.filterLeadConversionReport(p));
            this.calculateTotals();
        }

        private loadLeadBatches() {
            this.utilityService.showLoading()
            this.leadBatchService.retrieveLeadBatches()
                .then((leadBatches) => {
                    this.leadBatches = leadBatches.sort(function (a, b) {
                        return a.ActiveStart < b.ActiveStart ? 1 : -1;
                    });
                    this.leadBatches.forEach(function (batch) {
                        batch.Name = batch.Name ? batch.Name.split(" - ")[0] : "";
                        batch.StartDate = kendo.format("{0:MMM d}", batch.ActiveStart);
                        batch.EndDate = kendo.format("{0:MMM d}", batch.ActiveEnd);
                    });
                    return this.leadBatches;
                }).catch(ex => {
                    console.error(ex);
                    alert(`Initial load failed: ${this.utilityService.getExceptionMessage(ex)}`);
                })
                .then(() => this.utilityService.hideLoading());
        }

        private loadConversionReport() {
            const leadBatchIDs = this.selectedLeadBatches.map(function (batch) {
                return batch.LeadBatchID
            });
            const query = { BatchIDs: leadBatchIDs };
            return this.leadsService.retrieveLeadsConversionReport(query);
        }

        private calculateTotals() {
            this.staticTotals = this.filteredReport.reduce<Totals>(
                function (totals, count) {
                    totals.TotalLeads += count.TotalLeads;
                    totals.TotalAssignedLeads += count.TotalAssignedLeads;
                    totals.TotalUnAssignedLeads += count.TotalUnAssignedLeads;
                    return totals;
                },
                {
                    TotalLeads: 0, TotalAssignedLeads: 0, TotalUnAssignedLeads: 0
                });

            this.totals = [];
            for (let i = 0; i < this.reportHeaders.length; i++) {
                const columnTotals = this.filteredReport.reduce(function (columnTotals, payout) {
                    columnTotals.total += payout.Statuses[i].Count;
                    return columnTotals;
                }, { total: 0 });
                this.totals.push({ index: i, total: columnTotals.total });
            }
        }

        private filterLeadConversionReport(data) {

            return (!this.filters.Mapcode || this.utilityService.containsInvariant(data.Mapcode, this.filters.Mapcode))
                && (!this.filters.TeamName
                    || this.utilityService.containsInvariant(data.TeamName, this.filters.TeamName))
                && (!this.filters.City || this.utilityService.containsInvariant(data.City, this.filters.City))
                && (!this.filters.StartDate || moment(this.filters.StartDate).isSame(data.StartDate))
                && (!this.filters.EndDate || moment(this.filters.EndDate).isSame(data.EndDate));
        }
    }
}
